var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams icon",
    clipPath: "url(#clip0_0_212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layers",
    d: "M1.4994 8.99982C1.49905 9.14328 1.53984 9.28383 1.61695 9.4048C1.69406 9.52578 1.80424 9.6221 1.93443 9.68236L8.38488 12.615C8.5793 12.7031 8.79026 12.7486 9.00368 12.7486C9.2171 12.7486 9.42806 12.7031 9.62247 12.615L16.0579 9.68986C16.1907 9.63018 16.3032 9.53317 16.3818 9.41064C16.4604 9.28811 16.5016 9.14537 16.5005 8.99982M1.4994 12.75C1.49905 12.8935 1.53984 13.034 1.61695 13.155C1.69406 13.276 1.80424 13.3723 1.93443 13.4326L8.38488 16.3652C8.5793 16.4533 8.79026 16.4988 9.00368 16.4988C9.2171 16.4988 9.42806 16.4533 9.62247 16.3652L16.0579 13.4401C16.1907 13.3804 16.3032 13.2834 16.3818 13.1609C16.4604 13.0383 16.5016 12.8956 16.5005 12.75M9.62281 1.63468C9.42737 1.54553 9.21507 1.4994 9.00026 1.4994C8.78546 1.4994 8.57316 1.54553 8.37772 1.63468L1.94977 4.55984C1.81667 4.61852 1.70351 4.71465 1.62407 4.8365C1.54463 4.95835 1.50233 5.10067 1.50233 5.24613C1.50233 5.39159 1.54463 5.53391 1.62407 5.65576C1.70351 5.77761 1.81667 5.87373 1.94977 5.93242L8.38522 8.86508C8.58066 8.95422 8.79296 9.00035 9.00776 9.00035C9.22257 9.00035 9.43487 8.95422 9.63031 8.86508L16.0658 5.93992C16.1989 5.88123 16.312 5.78511 16.3915 5.66326C16.4709 5.54141 16.5132 5.39909 16.5132 5.25363C16.5132 5.10817 16.4709 4.96585 16.3915 4.844C16.312 4.72215 16.1989 4.62603 16.0658 4.56734L9.62281 1.63468Z",
    stroke: "#6B6F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.c992c949385a49fb1f218c5f6f56a2a7.svg";
export { ForwardRef as ReactComponent };